import { FC } from "react"
import { cn } from "@dashboard/lib/utils"
import { LockIcon } from "lucide-react"
import { AppButtonCardProps } from "./types"

const AppButtonCard: FC<AppButtonCardProps> = ({
  item,
  isDisabled,
  disableReason,
  onClick,
  onLockClick,
}) => (
  <div className="relative w-[128px]">
    <button
      key={`${item.appId}-${item.index}`}
      aria-disabled={isDisabled}
      aria-label={
        disableReason === "offline"
          ? `${item.label} — needs a connection to load offline`
          : disableReason === "subscription"
            ? `${item.label} — requires a subscription`
            : disableReason === "session"
              ? `${item.label} — session open on another device`
              : item.label
      }
      className={cn(
        "relative w-[128px] cursor-pointer rounded-[5px] border-[1px] border-[#E5E5E5] bg-white",
        isDisabled ? "cursor-not-allowed bg-[#F9FAFB]" : "active:scale-95",
      )}
      disabled={isDisabled}
      onClick={onClick}
    >
      <div className="p-2 flex aspect-video w-full flex-col items-center justify-center ">
        {/* Slightly smaller than the original 60px, with right padding, so
            the top-right lock icon never sits on top of the code letters. */}
        <div className="w-full pr-8 font-roboto bg-gradient-to-b from-[#0066FF] to-[#5EAFFF] bg-clip-text text-left text-[52px] font-bold italic leading-none text-transparent">
          {item.displayCode}
        </div>
        {/* Capped at 14px so the longest label ("Defensive Back") stays on
            ONE line in the 128px card — a wrapped label makes that card
            taller than its row. */}
        <div className="font-roboto text-left w-full whitespace-nowrap text-[13px] font-bold leading-[20px] text-[#1B2128] sm:text-[14px]">
          {item.label}
        </div>
      </div>
    </button>
    {/* ONE lock for every disabled state, and the lock itself is the
        affordance: tapping it opens a modal explaining why the app is locked
        (no subscription / session on another device / not installed for
        offline) with the matching action inside the modal. */}
    {isDisabled && onLockClick ? (
      <button
        type="button"
        title="Why is this locked?"
        aria-label={`Why is ${item.label} locked?`}
        onClick={(e) => {
          e.stopPropagation()
          onLockClick()
        }}
        className="absolute right-[5px] top-[8px] z-10 rounded p-0.5 text-[#9CA3AF] transition hover:bg-gray-100"
      >
        <LockIcon size={20} />
      </button>
    ) : null}
  </div>
)

export { AppButtonCard }
